import { render, staticRenderFns } from "./DeleteTargetTenantTable.vue?vue&type=template&id=517a10d1&"
import script from "./DeleteTargetTenantTable.vue?vue&type=script&lang=ts&"
export * from "./DeleteTargetTenantTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
